import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/yenlo.webp';
import screenshot_target from '../../../images/letterfunnel/diniklaassen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Dini Klaassen"
      firstname="Dini"
      companyname="Yenlo"
      competition="Alumio en Solvinity"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/diniklaassen.js